module.exports = __webpack_public_path__ + "img/calendar-green.78e7567e.svg";